import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 51.92 45.51",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#231f20;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M51.92,22.67a3.23,3.23,0,0,1-2,3L4.53,45.25a3.19,3.19,0,0,1-1.28.26,3.25,3.25,0,0,1-2.91-4.7l7.49-15,24.59-3.08L7.83,19.67.34,4.7A3.25,3.25,0,0,1,4.53.26L50.05,19.77A3.14,3.14,0,0,1,51.92,22.67Z"
		})
	]
});
const ForwardRef = forwardRef(SvgSendArrow);
export default ForwardRef;
